import React, { useState, useEffect } from "react";
import ReactPaginate from "react-paginate";
import { ManageSeasonModal } from "./Modal/ManageSeasonModal";
import { useDispatch } from "react-redux";
import { fetchData } from "../redux/apiSlice";
import { toastify, userlogout } from '../redux/controller';
import { useNavigate } from "react-router-dom";

const Settings = () => {


  const navigate = useNavigate();
  const usertoken = localStorage.getItem('usertoken');
  const [showEmptySeason, setShowEmptySeasons] = useState(false);
  const [seasons, setSeasonData] = useState([]);

  const [commissions, setCommissions] = useState(0);
  const [payouts, setPayouts] = useState(0);
  const [defaultAffiliateCommision, setDefaultAffiliateCommision] = useState('');
  const [perpage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(0);
  const [errors, setErrors] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleOpen = () => setIsModalOpen(true);
  const handleClose = () => setIsModalOpen(false);


  const dispatch = useDispatch();

  useEffect(() => {
    getSettings();
    getSeasonDetails();
  }, []);

  const getSettings = async () => {
    var settingsData = await dispatch(
      fetchData({
        apiurl: "/settings/getsettings",
        headers: { "x-access-token": usertoken }
      })
    );

    if (settingsData && settingsData.payload && settingsData.payload.setting) {
      setCommissions(settingsData.payload.setting.landownersCommisions)
      setPayouts(settingsData.payload.setting.minimumPayout)
      if (settingsData.payload.setting.defaultAffiliateCommision !== undefined) {
        setDefaultAffiliateCommision(settingsData.payload.setting.defaultAffiliateCommision);
      }
    }
    if (settingsData.payload.response && settingsData.payload.response.data&& settingsData.payload.response.data.message) {
      if (settingsData.payload.response.data.message === "Invalid token provided!" || settingsData.payload.response.data.message === "No token provided!") {
        // toastify({ message: 'Session expired' });
        userlogout();
        navigate('/');
      }
    }
  };

  const getSeasonDetails = async () => {

    var seasonList = await dispatch(
      fetchData({
        apiurl: "/season/getseasons",
        headers: { "x-access-token": usertoken }
      })
    );
    if (seasonList && seasonList.payload && seasonList.payload.seasons && seasonList.payload.seasons.length > 0) {
      setSeasonData(seasonList.payload.seasons)
    } else {
      setShowEmptySeasons(true)
    }
    if (seasonList.payload.response && seasonList.payload.response.data && seasonList.payload.response.data.message) {
      if (seasonList.payload.response.data.message === "Invalid token provided!"|| seasonList.payload.response.data.message === "No token provided!") {
        // toastify({ message: 'Session expired' });
        userlogout();
        navigate('/');
      }
    }
  };


  const StoreDataSeason = async (res) => {
    console.log(res)
    var savedSettings = await dispatch(
      fetchData({
        apiurl: "/season/createseason",
        seasonName: res.seasonName,
        seasonStartDate: res.seasonStartDate,
        seasonEndDate: res.seasonEndDate,
        headers: { "x-access-token": usertoken }
      })
    );


    if (savedSettings && savedSettings.payload && savedSettings.payload.season) {
      toastify({ message: savedSettings.payload.message });
    } else if (savedSettings?.payload?.response?.data?.message) {
      toastify({ message: savedSettings?.payload?.response?.data?.message });
    } else {
      toastify({ message: savedSettings.payload.message });
    }
    getSeasonDetails();
  }



  const inputperPage = (event) => {
    setPerPage(Number(event.target.value));
    setCurrentPage(0);
  };
  const handlePageClick = (selectedPage) => {
    setCurrentPage(selectedPage.selected);
  };

  const handleSaveAffiliateCommission = async () => {
    const value = parseFloat(defaultAffiliateCommision);

    if (isNaN(value) || value < 0) {
      toastify({ message: "Please enter a valid affiliate commission" });
      return;
    }

    if (value > 100) {
      toastify({ message: "Affiliate commission cannot be greater than 100%" });
      return;
    }

    var savedSettings = await dispatch(
      fetchData({
        apiurl: "/settings/savedefaultaffiliatecommision",
        defaultAffiliateCommision: value,
        headers: { "x-access-token": usertoken }
      })
    );

    if (savedSettings && savedSettings.payload && savedSettings.payload.setting) {
      toastify({ message: savedSettings.payload.message || "Default affiliate commission saved successfully" });
      setDefaultAffiliateCommision(savedSettings.payload.setting.defaultAffiliateCommision);
    } else {
      const errorMsg = savedSettings?.payload?.response?.data?.message || savedSettings?.payload?.message || "Failed to save affiliate commission";
      toastify({ message: errorMsg });
    }
  };

  const handleSave = async () => {
    const newErrors = {};
    if (!commissions) newErrors.commissions = "Commission is required";
    if (parseFloat(commissions) > 100) {
      newErrors.commissions = "Commission is not greater then 100%";
    }
    if (!payouts) newErrors.payouts = "Payouts is required";
    if (Object.keys(newErrors).length) {
      setErrors(newErrors);
      return;
    }
    setErrors({});
    const data = {
      landownersCommisions: parseFloat(commissions) || 0,
      minimumPayout: parseFloat(payouts) || 0,
    };

    console.log("Saved Settings:", data);

    var savedSettings = await dispatch(
      fetchData({
        apiurl: "/settings/savesettings",
        landownersCommisions: parseFloat(commissions) || 0,
        minimumPayout: parseFloat(payouts) || 0,
        headers: { "x-access-token": usertoken }
      })
    );
    if (savedSettings && savedSettings.payload && savedSettings.payload.message) {
      toastify({ message: savedSettings.payload.message });
    } else {
      toastify({ message: savedSettings.payload.message });
    }

  };

  const handleCommissionsChange = (e) => {
    const value = e.target.value;
    setCommissions(value);

    if (errors.commissions && value.trim()) {
      setErrors((prev) => ({ ...prev, commissions: "" }));
    }
  };

  const handlePayoutsChange = (e) => {
    const value = e.target.value;
    setPayouts(value);

    if (errors.payouts && value.trim()) {
      setErrors((prev) => ({ ...prev, payouts: "" }));
    }
  };

  const offset = currentPage * perpage;
  const paginatedSeasons = seasons.slice(offset, offset + perpage);

  return (
    <div className="settings_main-div">
      <div className="add-formdiv-pro Property details_inner_section">
        <div className="add-main">
          <div className="add-formdiv">
            <div className="add-top">
              <div className="slot-datetable">
                <div className="slot-datetable1">
                  <h2>Commission Settings</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="add-form">
          <div className="select-div">
            <div className="select-div1">
              <label
                htmlFor="exampleInputEmail1"
                className="form-label required"
              >
                Default Landowner Commission (%):
              </label>
              <input
                type="number"
                value={commissions}
                onChange={handleCommissionsChange}
                className="form-control"
                placeholder="Enter Commission"
              />
              {errors.commissions && (
                <div style={{ color: "red", fontSize: "13px" }}>
                  {errors.commissions}
                </div>
              )}
            </div>
            <div className="select-div2">
              <label
                htmlFor="exampleInputEmail1"
                className="form-label required"
              >
                Minimum Landowner Payout Amount ($):
              </label>
              <input
                type="number"
                className="form-control"
                value={payouts}
                onChange={handlePayoutsChange}
                placeholder="Enter amount"
              />
              {errors.payouts && (
                <div style={{ color: "red", fontSize: "13px" }}>
                  {errors.payouts}
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="search-div">
          <div className="hunder_head_row_tabel">
            <button className="add-btn" onClick={handleSave}>
              Save
            </button>
          </div>
        </div>
      </div>

      <div className="add-formdiv-pro Property details_inner_section" style={{ marginTop: '24px' }}>
        <div className="add-main">
          <div className="add-formdiv">
            <div className="add-top">
              <div className="slot-datetable">
                <div className="slot-datetable1">
                  <h2>Affiliate Commission Settings</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="add-form">
          <div className="select-div">
            <div className="select-div1">
              <label className="form-label required">
                Default Affiliate Commission (%):
              </label>
              <input
                type="number"
                className="form-control"
                placeholder="Enter Affiliate Commission"
                value={defaultAffiliateCommision}
                onChange={(e) => setDefaultAffiliateCommision(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="search-div">
          <div className="hunder_head_row_tabel">
            <button className="add-btn" onClick={handleSaveAffiliateCommission}>
              Save
            </button>
          </div>
        </div>
      </div>

      {/* <div className="add-formdiv-pro Property details_inner_section"> */}
      <div className="add-main">
        <div className="add-formdiv">
          <div className="add-top">
            <div className="slot-datetable">
              <div className="slot-datetable1">
                <h2>Manage Season</h2>
              </div>
              <div className="manage_settings_buttons">
                <button className="add-btn" onClick={handleOpen}>
                  + Create new season
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="managecoupons-table add-form setting-table">
        <div className="add-table">
          <table className="table">
            <thead>
              <tr>
                <th>Season Name</th>
                <th>Start Date</th>
                <th>End Date</th>
              </tr>
            </thead>

            <tbody>


              {paginatedSeasons.length > 0 ? (
                paginatedSeasons.map((season, index) => {
                  const now = new Date();
                  const start = new Date(season.seasonStartDate);
                  const end = new Date(season.seasonEndDate);
                  const isCurrent = now >= start && now <= end;

                  return (
                    <tr key={index}>
                      <td>
                        {season.seasonName}
                        {isCurrent && (
                          <span style={{
                            marginLeft: '10px',
                            backgroundColor: '#28a745',
                            color: 'white',
                            padding: '2px 6px',
                            borderRadius: '4px',
                            fontSize: '12px'
                          }}>
                            Current Season
                          </span>
                        )}
                      </td>
                      <td>{start.toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' })}</td>
                      <td>{end.toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' })}</td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="3" style={{ textAlign: 'center', padding: '20px' }}>
                    No season found
                  </td>
                </tr>
              )}

            </tbody>
          </table>
        </div>

        <div className="rowperpage">
          <div className="perpagecount">
            Row Per Page
            <select onChange={inputperPage} value={perpage}>
              <option value={10}>10</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
              <option value={150}>150</option>
              <option value={200}>200</option>
            </select>
          </div>

          <ReactPaginate
            pageCount={Math.ceil(seasons.length / perpage)}
            pageRangeDisplayed={perpage}
            breakLabel={"..."}
            marginPagesDisplayed={2}
            onPageChange={handlePageClick}
            containerClassName={"pagination"}
            pageClassName={"page-item"}
            pageLinkClassName={"page-link"}
            activeClassName={"active"}
          />
        </div>
      </div>
      {/* Modal Component */}
      <ManageSeasonModal popstatus={isModalOpen} handleClose={handleClose} StoreDataSeason={StoreDataSeason} />
      {/* </div> */}
    </div>
  );
};

export default Settings;
